import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  columnViewTree: {
    display: "table",
    borderSpacing: '0px',
    fontSize: '16px',
    '& tr': {
      verticalAlign: 'baseline',
      display: 'table-cell',
      'border-right': '1px solid #dadada',
    },
    '& tr td': {
      display: 'block',
      padding: '3px 10px',
      color: 'black',
    },
    '& tr:last-of-type': {
      border: 'none'
    },
    '& tr:first-of-type td': {
      paddingLeft: '0px',
    },
  },
});
